import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getRetryDelay, shouldRetryRequest } from '@/shared/lib/query/retryConfig';

import { experimentManagementApi } from '@/entities/experiment/api/experimentManagementApi';
import type {
  ExperimentListResponse,
  GetExperimentsParams,
} from '@/entities/experiment/domain/experimentManagementTypes';

export const EXPERIMENT_MANAGEMENT_QUERY_KEY = 'experiment-management';

export const useExperimentManagementList = (params?: GetExperimentsParams, enabled = true) => {
  return useQuery<ExperimentListResponse>({
    queryKey: [EXPERIMENT_MANAGEMENT_QUERY_KEY, params],
    queryFn: () => experimentManagementApi.getList(params),
    enabled,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: shouldRetryRequest,
    retryDelay: getRetryDelay,
    placeholderData: keepPreviousData,
  });
};
